import { Box, Grid, IconButton, Typography, useTheme } from "@mui/material"
import React, { useState } from "react"
import styles from "../../../PendingQuestionTable.module.scss"
import ArrowForwardIcon from "@mui/icons-material/ArrowForward"
import EditIcon from "@mui/icons-material/Edit"
import EditSuggestedQuestion from "../../EditSuggestedQuestion"
import { useDispatch } from "react-redux"
import { learningDevelopmentActions } from "redux/L&D/slice/user"
import { getEditTriviaQuestionsAction } from "redux/L&D/actions/user"

const Question = ({ row, index, isEdit }) => {
  const [openEditDialog, setOpenEditDialog] = useState(false)
  const dispatch = useDispatch()
  const theme = useTheme()

  const handleEditDialogOpen = () => {
    dispatch(learningDevelopmentActions.setSuggestedQuestionEdited(false))
    setOpenEditDialog(true)
  }

  const handleEditDialogClose = () => {
    setOpenEditDialog(false)
  }

  const onQuestionEdited = () => {
    dispatch(getEditTriviaQuestionsAction())
  }

  const isQuestionEditable = () => {
    if (!row?.suggested_by) {
      return true
    }
    return row?.status?.toLowerCase() !== "approved"
  }

  return (
    <Box className={styles.question}>
      {openEditDialog ? (
        <EditSuggestedQuestion
          isEdit={isEdit}
          onClose={handleEditDialogClose}
          data={row}
          onQuestionEdited={onQuestionEdited}
        />
      ) : null}
      <Typography
        sx={{ margin: "0px 0px 4px 52px" }}
        color={theme.palette.secondary.main}
        variant="caption3"
        style={{ opacity: 1 }}
        className={styles.questionHeader}>
        {`${row?.question_platform === "VIP" ? "VIP" : row?.category ?? "-"} | ${
          row?.filter_category
        } ${row?.food_name ? `| ${row?.food_name}` : ""}`}
      </Typography>
      <Box className={styles.questionTitle}>
        <Typography variant="body1Regular">{index + 1}</Typography>
        <ArrowForwardIcon sx={{ marginLeft: "14px" }} />
        <Typography variant="h4" sx={{ marginLeft: "6px" }}>
          {row.title}
        </Typography>
        {isQuestionEditable() ? (
          <span className="ms-1" onClick={handleEditDialogOpen}>
            <IconButton
              sx={(theme) => ({
                color: theme.palette.secondary.main
              })}>
              <EditIcon
                sx={{
                  height: 20,
                  width: 20
                }}
              />
            </IconButton>
          </span>
        ) : null}
      </Box>
      <div className="d-flex">
        {row?.question_type === "text" || row?.question_type === "soundbite"
          ? row?.answer?.map((option, index) => (
              <Box
                key={option.id}
                className={`${styles.option} ${option.is_correct ? styles.optionCorrect : ""}`}>
                <div className={styles.optionNumber}>
                  <Typography variant="tag1">{(index + 10).toString(36).toUpperCase()}</Typography>
                </div>
                <Typography
                  className={styles.optionName}
                  sx={{ marginLeft: "10px" }}
                  variant="body2Regular">
                  {option.answer}
                </Typography>
              </Box>
            ))
          : row?.question_type === "matching"
          ? row?.match_pairs?.map((pair, index) => (
              <Box key={index} className={`${styles.option}`}>
                <Box className={styles.optionNumber}>
                  <Typography variant="tag1">{(index + 10).toString(36).toUpperCase()}</Typography>
                </Box>
                <Box className="d-flex flex-column ps-3">
                  <Typography className={styles.optionName} variant="body2Regular">
                    {pair?.left_text}
                  </Typography>
                  <Typography
                    className={styles.optionName}
                    variant="body2Regular"
                    color={theme.palette.success.main}>
                    {pair?.right_text}
                  </Typography>
                </Box>
              </Box>
            ))
          : row?.answer?.map((option) => (
              <Grid key={option.id} item xs={3} gap={2}>
                <Box
                  className={`${styles.option} ${styles.question_bank_image_option} ${
                    option?.is_correct ? styles.optionCorrect : ""
                  }`}>
                  <img
                    src={option?.answer_image_url}
                    alt="option"
                    className={`${styles.optionImage} ${
                      option?.is_correct ? styles.optionCorrectImage : ""
                    }`}
                  />
                  <Typography
                    className={`${styles.optionName} ${styles.question_bank_image_option_name}`}
                    variant="body2Regular">
                    {option?.answer && option?.answer.length > 18
                      ? `${option?.answer.substring(0, 15)}...`
                      : option?.answer || "-"}
                  </Typography>
                </Box>
              </Grid>
            ))}
      </div>
    </Box>
  )
}

export default Question
